import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { RoutesPaths } from "../Router/constant";
import { useDispatch } from "react-redux";
import { loginAction } from "../actions/auth";
import toast from "react-hot-toast";
import { IS_LOGIN } from "../actions/type";

export function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    dispatch({ type: IS_LOGIN, payload: !!token });
  }, [dispatch]);

  const validate = () => {
    const newErrors = {};

    if (!email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(email))
      newErrors.email = "Invalid email format";

    if (!password) newErrors.password = "Password is required";
    else if (password.length < 6) newErrors.password = "Minimum 6 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const payload = {
        email: email,
        password: password,
      };
      const response = await dispatch(loginAction(payload));
      if (response?.status === 200) {
        localStorage.setItem("authToken", response?.data?.token);
        navigate(RoutesPaths.DASHBOARD);
      }
    } catch (error) {
      toast.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            <div className="w-lg-500px p-10">
              <form className="form w-100" onSubmit={handleSubmit}>
                <div className="text-center mb-11">
                  <h1 className="text-gray-900 fw-bolder mb-3">Sign In</h1>
                  <div className="text-gray-500 fw-semibold fs-6">
                    Miaxa is a location-based app that helps you discover nearby places and navigate easily.
                  </div>
                </div>

                {/* SOCIAL BUTTONS - unchanged */}
                {/* <div className="row g-3 mb-9">
                  <div className="col-md-6">
                    <Link
                      to="#"
                      className="btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
                    >
                      <img
                        alt="Logo"
                        src="/assets/media/svg/brand-logos/google-icon.svg"
                        className="h-15px me-3"
                      />
                      Sign in with Google
                    </Link>
                  </div>
                  <div className="col-md-6">
                    <Link
                      to="#"
                      className="btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
                    >
                      <img
                        alt="Logo"
                        src="/assets/media/svg/brand-logos/apple-black.svg"
                        className="theme-light-show h-15px me-3"
                      />
                      <img
                        alt="Logo"
                        src="/assets/media/svg/brand-logos/apple-black-dark.svg"
                        className="theme-dark-show h-15px me-3"
                      />
                      Sign in with Apple
                    </Link>
                  </div>
                </div>

                <div className="separator separator-content my-14">
                  <span className="w-125px text-gray-500 fw-semibold fs-7">
                    Or with email
                  </span>
                </div> */}

                {/* EMAIL */}
                <div className="fv-row mb-8">
                  <input
                    type="text"
                    placeholder="Email"
                    name="email"
                    className={`form-control bg-transparent ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>

                {/* PASSWORD */}
                <div className="fv-row mb-3">
                  <input
                    type="password"
                    placeholder="Password"
                    name="password"
                    className={`form-control bg-transparent ${
                      errors.password ? "is-invalid" : ""
                    }`}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                  )}
                </div>

                <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                  <div></div>
                </div>

                {/* SUBMIT */}
                <div className="d-grid mb-10">
                  <button
                    type="submit"
                    className="btn buttonPrimary"
                    disabled={loading}
                  >
                    {!loading && (
                      <span className="indicator-label">Sign In</span>
                    )}
                    {loading && (
                      <span className="indicator-label">
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        Please wait...
                      </span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE - unchanged */}
        <div
          className="height100vh d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
          style={{ backgroundImage: "url(/assets/media/misc/auth-bg.png)" }}
        >
          <div className="d-flex flex-column flex-center py-7 py-lg-10 px-5 px-md-10 w-100">
            <Link to="" className="mb-0 mb-lg-12">
              <img
                alt="Logo"
                src="/assets/media/logos/miaxaLogo.svg"
                className="h-60px h-lg-75px"
              />
            </Link>
            <img
              className="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-400px mb-10 mb-lg-20"
              src="/assets/media/misc/authbanner.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}
